// ===========================================
// Enquiry / Onboarding check-in query-key roots
// ===========================================
// A leaf module (imports nothing) so a hook outside the enquiry screens, such as the enrolment
// mutations in useLessons.ts, can invalidate these without an import cycle through
// useEnquiries -> useHybridBooking -> useLessons.

export const ENQUIRY_KEY_ROOT = ['enquiries'] as const;

/** The Onboarding check-in's key root (`settlingInKeys.all` is built from it). */
export const SETTLING_IN_KEY_ROOT = ['settling-in'] as const;
